import { atom } from 'recoil';
import { Preferences } from 'generated-graphql/types';

export const preferencesAtom = atom<Preferences | null>({
  key: 'preferencesAtom',
  default: null
});
